var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhistle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48926 6.56836C5.30744 6.56836 4.17402 7.03784 3.33835 7.87351C2.50268 8.70918 2.0332 9.8426 2.0332 11.0244C2.0332 11.6096 2.14846 12.189 2.3724 12.7297C2.59634 13.2703 2.92457 13.7615 3.33835 14.1753C4.17402 15.011 5.30744 15.4805 6.48926 15.4805C7.07444 15.4805 7.65388 15.3652 8.19452 15.1413C8.73515 14.9173 9.22638 14.5891 9.64016 14.1753C10.0539 13.7615 10.3822 13.2703 10.6061 12.7297C10.8301 12.189 10.9453 11.6096 10.9453 11.0244V9.93439L15.7441 8.625V6.56836H8.20312V7.93945H6.83203V6.56836H6.48926ZM8.20312 1.76953V5.19727H6.83203V1.76953H8.20312ZM5.01533 5.38922C4.55602 5.49891 4.11727 5.66344 3.69908 5.88281L2.12918 3.74391L3.23977 2.93496L5.01533 5.38922ZM12.906 3.74391L11.8502 5.19727H10.1569L11.7954 2.93496L12.906 3.74391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle);
export default __webpack_public_path__ + "static/media/whistle.8bf86539693cb227f67b6bbe5780941e.svg";
export { ForwardRef as ReactComponent };